import React, { useCallback } from "react";
import {
  PipecatClientProvider,
  PipecatClientAudio,
  usePipecatClient,
  useRTVIClientEvent,
} from "@pipecat-ai/client-react";
import { PipecatClient, RTVIEvent } from "@pipecat-ai/client-js";
import { SmallWebRTCTransport } from "@pipecat-ai/small-webrtc-transport";

function StateLogger() {
  // 1) Subscribe to standardized RTVI events
  useRTVIClientEvent(
    RTVIEvent.BotStartedSpeaking,
    useCallback(() => console.log("🤖 Bot started speaking"), [])
  );
  useRTVIClientEvent(
    RTVIEvent.BotStoppedSpeaking,
    useCallback(() => console.log("🤖 Bot stopped speaking → listening"), [])
  );
  useRTVIClientEvent(
    RTVIEvent.UserStartedSpeaking,
    useCallback(() => console.log("🧑 You started speaking"), [])
  );
  useRTVIClientEvent(
    RTVIEvent.UserStoppedSpeaking,
    useCallback(() => console.log("🧑 You stopped speaking"), [])
  );

useRTVIClientEvent(
    RTVIEvent.ServerMessage,
    React.useCallback((msg) => {
      // msg is exactly what you sent from the server
      // e.g. { label: "state", type: "session", data: { status: "connected" } }
      if (!msg || msg.label !== "state") return;
        switch (msg.type) {
            case "session":
              console.log("📶 Session:", msg.data?.status);
              break;
            default:
              break;
        }
    }, [])
  );

  return null;
}

function VoiceControls() {
  const client = usePipecatClient();

  const start = async () => {
    await client.connect({ webrtcUrl: "http://localhost:7860/api/offer" });
  };

  return (
    <div>
      <button onClick={start}>Connect</button>
      <PipecatClientAudio />
      <StateLogger />
    </div>
  );
}

export default function PipecatVoiceBot() {
  const client = React.useMemo(() => {
    return new PipecatClient({
      transport: new SmallWebRTCTransport({
        enableMic: true,
        enableSpeaker: true,
      }),
      enableMic: true,
      enableCam: false,
    });
  }, []);

  return (
    <PipecatClientProvider client={client}>
      <VoiceControls />
    </PipecatClientProvider>
  );
}